import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import PropTypes from 'prop-types';
import { object } from 'yup';
import { TextInput } from '../../../Helpers/Inputs';
import { NumberFormatDollars } from '../../../Helpers/Formatters';
import BasicDetails from '../../BasicDetails';
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined';
import { number as yupnumber } from "../../../Helpers/Validators/customValidators";
import BackNextButton from '../../../Common/BackNextButton';import FormHeader from './FormHeader';

export default function FinancialInfo(props) {
  const maritalStatus = props.fullFormState.pages.clientBasicInfo.maritalStatus;
  const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
    validationSchema: FinancialInfo.ValidationSchema(maritalStatus),
    mode: 'onBlur',
    reValidateMode: 'onBlur'
  });
  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);
  };

  useEffect(() => {
    register({ name: 'mainIncome' });
    setValue('mainIncome', props.formState.mainIncome);

    register({ name: 'spouseIncome' });
    setValue('spouseIncome', props.formState.spouseIncome);

    register({ name: 'otherIncome' });
    setValue('otherIncome', props.formState.otherIncome);

    register({ name: 'liquidAssets' });
    setValue('liquidAssets', props.formState.liquidAssets);

    register({ name: 'retirementAssets' });
    setValue('retirementAssets', props.formState.retirementAssets);

    register({ name: 'otherAssets' });
    setValue('otherAssets', props.formState.otherAssets);

    register({ name: 'mortgage' });
    setValue('mortgage', props.formState.mortgage);

    register({ name: 'debt' });
    setValue('debt', props.formState.debt);
  }, [register]);

  const onSubmit = () => {
    let newFormState = props.fullFormState;
    let noIncome = false;
    newFormState.pages.clientBasicInfo.needsDI = true;//set NeedDI to true by default

    if (Number(newFormState.pages.financialInfo.mainIncome) < 18000 || (newFormState.pages.clientBasicInfo.clientAge < 18 || newFormState.pages.clientBasicInfo.clientAge > 61)) {
      newFormState.pages.clientBasicInfo.needsDI = false;
    }

    if (newFormState.pages.clientBasicInfo.maritalStatus === 'Married') {
      if (Number(newFormState.pages.financialInfo.mainIncome) === 0 && Number(newFormState.pages.financialInfo.spouseIncome) === 0 && Number(newFormState.pages.financialInfo.otherIncome === 0)) {
        noIncome = true;
      }
    }
    else {
      if (Number(newFormState.pages.financialInfo.mainIncome === 0) && Number(newFormState.pages.financialInfo.otherIncome === 0)) {
        noIncome = true;
      }
    }

    if (noIncome) {
      newFormState.pages.clientBasicInfo.needsLife = false;
      newFormState.pages.clientBasicInfo.needsFinalExpense = false;
      newFormState.pages.clientBasicInfo.needsEstatePlanning = false;
      newFormState.pages.clientBasicInfo.needsDI = false;
      newFormState.pages.clientBasicInfo.needsLTC = false;
      newFormState.pages.clientBasicInfo.needsIncome = true;
    }

    if (newFormState.pages.clientBasicInfo.needsLife === true) {
      newFormState.pages.financialInfo.hasAdditionalClientInfoStep = true;
    }

    if (newFormState.pages.clientBasicInfo.needsDI === true) {
      newFormState.pages.financialInfo.hasMonthlyExpensesStep = true;
    }
    props.onMultiFieldChange(newFormState);
    props.onNext();
  }

  return (
    <div>
      <Container fluid className="border-class">
        <Form onSubmit={handleSubmit(onSubmit)}>
        {props.StartOverButton}
          <Row className="justify-content-center pt-3 client-coverage">
            <Col lg={4} className='analysis-info'>
             <FormHeader title="Client's Financial Information" />
              <Form.Group>
                <h6>Income</h6>
                <TextInput
                  name="mainIncome"
                  id="mainIncome"
                  label="Client's Annual Net Income"
                  value={props.formState.mainIncome}
                  onChange={e => handleValueChange('mainIncome', e.target.value)}
                  errors={errors.mainIncome}
                  inputRef={register}
                  InputProps={{
                    inputComponent: NumberFormatDollars
                  }}
                />
              </Form.Group>
              {
                maritalStatus === 'Married' &&
                <Form.Group>
                  <TextInput
                    name="spouseIncome"
                    id="spouseIncome"
                    label="Client's Spouse Annual Net Income"
                    value={props.formState.spouseIncome}
                    onChange={e => handleValueChange('spouseIncome', e.target.value)}
                    errors={errors.spouseIncome}
                    inputRef={register}
                    InputProps={{
                      inputComponent: NumberFormatDollars
                    }}
                  />
                </Form.Group>
              }
              <Form.Group>
                <TextInput
                  name="otherIncome"
                  id="otherIncome"
                  label="Client's Other Annual Net Income"
                  value={props.formState.otherIncome}
                  onChange={e => handleValueChange('otherIncome', e.target.value)}
                  errors={errors.otherIncome}
                  inputRef={register}
                  InputProps={{
                    inputComponent: NumberFormatDollars
                  }}
                />
              </Form.Group>

              <Form.Group>
                <h6>Assets</h6>
                <TextInput
                  name="liquidAssets"
                  id="liquidAssets"
                  label="Client's Liquid Assets"
                  value={props.formState.liquidAssets}
                  onChange={e => handleValueChange('liquidAssets', e.target.value)}
                  errors={errors.liquidAssets}
                  inputRef={register}
                  InputProps={{
                    inputComponent: NumberFormatDollars
                  }}
                />
              </Form.Group>

              <Form.Group>
                <TextInput
                  name="retirementAssets"
                  id="retirementAssets"
                  label="Client's Retirement Assets"
                  value={props.formState.retirementAssets}
                  onChange={e => handleValueChange('retirementAssets', e.target.value)}
                  errors={errors.retirementAssets}
                  inputRef={register}
                  InputProps={{
                    inputComponent: NumberFormatDollars
                  }}
                />
              </Form.Group>

              <Form.Group>
                <TextInput
                  name="otherAssets"
                  id="otherAssets"
                  label="Client's Other Assets"
                  value={props.formState.otherAssets}
                  onChange={e => handleValueChange('otherAssets', e.target.value)}
                  errors={errors.otherAssets}
                  inputRef={register}
                  InputProps={{
                    inputComponent: NumberFormatDollars
                  }}
                />
              </Form.Group>

              <Form.Group>
                <h6>Liabilities</h6>
                <TextInput
                  name="mortgage"
                  id="mortgage"
                  label="Client's Mortgage Balance"
                  value={props.formState.mortgage}
                  onChange={e => handleValueChange('mortgage', e.target.value)}
                  errors={errors.mortgage}
                  inputRef={register}
                  InputProps={{
                    inputComponent: NumberFormatDollars
                  }}
                />
              </Form.Group>

              <Form.Group>
                <TextInput
                  name="debt"
                  id="debt"
                  label="Client's Other Total Debt"
                  value={props.formState.debt}
                  onChange={e => handleValueChange('debt', e.target.value)}
                  errors={errors.debt}
                  inputRef={register}
                  InputProps={{
                    inputComponent: NumberFormatDollars
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
          <BackNextButton onBack={props.onBack} />
        </Form>
      </Container>
      <BasicDetails
        fullFormState={props.fullFormState}
      />
    </div>
  );
}

FinancialInfo.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired
};

FinancialInfo.ValidationSchema = (maritalStatus) => {
  return (
    object().shape({
      mainIncome: yupnumber()
        .transform(emptyStringToUndefined)
        .required("This field is required.")
        .max(2500000, "Amount must be less than or equal to $2,500,000."),
      spouseIncome: maritalStatus === 'Married' ? yupnumber()
        .transform(emptyStringToUndefined)
        .required("This field is required.")
        .max(2500000, "Amount must be less than or equal to $2,500,000.") :
        yupnumber().nullable()
          .transform(emptyStringToUndefined)
          .notRequired(),
      otherIncome: yupnumber()
        .transform(emptyStringToUndefined)
        .required("This field is required.")
        .max(2500000, "Amount must be less than or equal to $2,500,000."),
      liquidAssets: yupnumber()
        .transform(emptyStringToUndefined)
        .required("This field is required.")
        .max(10000000, "Amount must be less than or equal to $10,000,000."),
      retirementAssets: yupnumber()
        .transform(emptyStringToUndefined)
        .required("This field is required.")
        .max(10000000, "Amount must be less than or equal to $10,000,000."),
      otherAssets: yupnumber()
        .transform(emptyStringToUndefined)
        .required("This field is required.")
        .max(10000000, "Amount must be less than or equal to $10,000,000."),
      mortgage: yupnumber()
        .transform(emptyStringToUndefined)
        .required("This field is required.")
        .max(10000000, "Amount must be less than or equal to $10,000,000."),
      debt: yupnumber()
        .transform(emptyStringToUndefined)
        .required("This field is required.")
        .max(10000000, "Amount must be less than or equal to $10,000,000."),
    })
  )
}

FinancialInfo.DefaultFormState = (prefill = false) => {
  return {
    mainIncome: prefill ? '50000' : '',
    spouseIncome: prefill ? '50000' : '',
    otherIncome: prefill ? '15000' : '',
    liquidAssets: prefill ? '5250' : '',
    retirementAssets: prefill ? '0' : '',
    otherAssets: prefill ? '0' : '',
    mortgage: prefill ? '275750' : '',
    debt: prefill ? '0' : '',
    hasAdditionalClientInfoStep: false,
    HasMonthlyExpensesStep: false,
  };
};



// WEBPACK FOOTER //
// ./src/components/InsuranceTools/NeedsAnalysis/steps/FinancialInfo.js